import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>ESR Group Sigorta</h3>
          <p>Güvenilir sigorta çözümleri için yanınızdayız.</p>
        </div>

        <div className="footer-section">
          <h4>Hızlı Linkler</h4>
          <ul>
            <li><Link to="/">Ana Sayfa</Link></li>
            <li><Link to="/hakkımızda">Hakkımızda</Link></li>
            <li><Link to="/hizmetler">Hizmetler</Link></li>
            <li><Link to="/iletisim">İletişim</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Hizmetlerimiz</h4>
          <ul>
            <li><Link to="/hizmetler?service=saglik">Sağlık Sigortası</Link></li>
            <li><Link to="/hizmetler?service=isyeri">İşyeri Sigortası</Link></li>
            <li><Link to="/hizmetler?service=konut">Konut Sigortası</Link></li>
            <li><Link to="/hizmetler?service=trafik">Trafik Sigortası</Link></li>
            <li><Link to="/hizmetler?service=sorumluluk">Sorumluluk Sigortası</Link></li>
            <li><Link to="/hizmetler?service=seyahat">Seyahat-Sağlık Sigortası</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>İletişim</h4>
          <p>📧 Email: <a href="mailto:info@esrgroupsigorta.com.tr">info@esrgroupsigorta.com.tr</a></p>
          <p>📱 Telefon: <a href="tel:+905073933413">0507 393 34 13</a></p>
          <p>📍 Adres: Barbaros Hayrettin Paşa Mah., 1992. Sk., Vetro City, No: 16/43, Esenyurt/İstanbul</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2009 ESR Group Sigorta Aracılık Hizmetleri Limited Şirket. Tüm hakları saklıdır.</p>
      </div>
    </footer>
  );
};

export default Footer;

